var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('hr',{staticStyle:{"background-color":"#2E8037","height":"1px","border":"#2E8037"}})])
}]

export { render, staticRenderFns }